import { lazy } from 'react';

const CharityVettingCompanyNumberRoute = lazy(
  () =>
    import(
      /* webpackChunkName: "CompanyNumber" */ '../components/steps/company-number-step/CompanyNumber'
    ),
);

export default CharityVettingCompanyNumberRoute;
